import { recoverableItemsFolderName } from './loadDumpster.locstring.json';
import loc from 'owa-localize';
import folderStore, { Folder } from 'owa-folders';
import getFolderData from 'owa-mail-actions/lib/getFolderData';
import folderNameToId from 'owa-session-store/lib/utils/folderNameToId';

/**
 * Add dumpster to folder table
 * @param dumpsterFolderIdName - Distinguished folder name
 */
export function loadDumpster(dumpsterFolderIdName: string) {
    const dumpsterFolderId = folderNameToId(dumpsterFolderIdName);
    const isDumpsterInFolderTable = folderStore.folderTable.has(dumpsterFolderId);

    if (!isDumpsterInFolderTable) {
        const dumpsterFolder: Folder = {
            ...{
                UnreadCount: 0,
                TotalCount: -1, // Set as -1 so that we show spinner in the UI until we get real count from server
                FolderId: { Id: dumpsterFolderId },
                DistinguishedFolderId: dumpsterFolderIdName,
                DisplayName: loc(recoverableItemsFolderName),
            },
        };

        folderStore.folderTable.set(dumpsterFolderId, dumpsterFolder);
        getFolderData(dumpsterFolderId);
    }
}
